import MxTypography from "@rf-l1/MxTypography";
import { useEffect, useState } from "react";
import TypographyOverlay from "./TypographyOverlay";
import { useOverlayNotification } from "../hook/useOverlayNotification";

interface ManualRenderMessageOverlayProps {
  id: string;
}
export const ManualRenderMessageOverlay = (
  props: ManualRenderMessageOverlayProps
) => {
  const { message } = useOverlayNotification(props.id);

  if (typeof message === "string") {
    return <TypographyOverlay text={message} />;
  } else {
    return <>{message}</>;
  }
};

interface AutoRenderMessageOverlayProps {
  time?: number;
  messages: string[];
}
export const AutoRenderMessageOverlay = (props: AutoRenderMessageOverlayProps) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex(prev =>
        prev === props.messages.length - 1 ? 0 : prev + 1
      );
    }, props.time || 3000);

    return () => clearInterval(interval);
  }, [props.messages?.length, props?.time]);

  return <TypographyOverlay text={props.messages[currentMessageIndex]} />;
};
